import { hashEmail } from '@localstack/services';
import { Avatar } from '@mui/material';
import { ReactElement } from 'react';

type UserAvatarProps = {
  email: string;
};

export const UserAvatar = ({ email }: UserAvatarProps): ReactElement => (
  <Avatar
    alt={email}
    src={`https://www.gravatar.com/avatar/${hashEmail(email)}?d=identicon`}
    sx={{ width: (theme) => theme.spacing(4), height: (theme) => theme.spacing(4) }}
  />
);
